import '../sass/style.scss';

import Vue from 'vue';
import ProductFirewood from './components/product-firewood.vue';
import ProductSimple from './components/product-simple.vue';
import ProductVariable from './components/product-variable.vue';
import PostcodeModal from './components/postcode-modal.vue';
import DeliveryBlock from './components/delivery-page-block.vue';
import CheckoutLocalDelivery from './components/checkout-local-delivery.vue';

Vue.config.productionTip = false

if (jQuery('#product_firewood').length > 0) {
	const product_firewood = new Vue({
	  render: h => h(ProductFirewood),
	}).$mount('#product_firewood')
}

if (jQuery('#product_simple').length > 0) {
	const product_simple = new Vue({
	  render: h => h(ProductSimple),
	}).$mount('#product_simple')
}

if (jQuery('#product_variable').length > 0) {
	const product_variable = new Vue({
	  render: h => h(ProductVariable),
	}).$mount('#product_variable')
}

if (jQuery('.fp_check_postcode').length > 0) {
	const postcode_modal = new Vue({
	  render: h => h(PostcodeModal),
  }).$mount('#postcode_modal')
}

if (jQuery('.delivery-banner').length > 0) {
	const delivery_block = new Vue({
	  render: h => h(DeliveryBlock),
  }).$mount('#postcode_block')
}

if (jQuery('.checkout_step--local').length > 0) {
	const checkout_local_delivery = new Vue({
	  render: h => h(CheckoutLocalDelivery),
  }).$mount('#local_delivery')
}

import './script.js';
